import { render, staticRenderFns } from "./specification.vue?vue&type=template&id=4b79e69a&scoped=true&"
import script from "./specification.vue?vue&type=script&lang=js&"
export * from "./specification.vue?vue&type=script&lang=js&"
import style0 from "./specification.vue?vue&type=style&index=0&id=4b79e69a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b79e69a",
  null
  
)

component.options.__file = "specification.vue"
export default component.exports